import React from 'react';
import { Clock, Play, Check, X, Circle, PlayCircle, Upload, RefreshCw, CheckCircle, XCircle } from 'lucide-react';
import { StatusBadgeConfig } from '../../types/contract';

interface StatusBadgeProps {
  config: StatusBadgeConfig;
  size?: 'sm' | 'md' | 'lg';
  showIcon?: boolean;
}

const iconMap: Record<string, React.ComponentType<{ className?: string }>> = {
  clock: Clock,
  play: Play,
  check: Check,
  x: X,
  circle: Circle,
  'play-circle': PlayCircle,
  upload: Upload,
  'refresh-cw': RefreshCw,
  'check-circle': CheckCircle,
  'x-circle': XCircle,
};

export const StatusBadge: React.FC<StatusBadgeProps> = ({
  config,
  size = 'md',
  showIcon = true,
}) => {
  const Icon = config.icon ? iconMap[config.icon] : null;

  const sizeClasses = {
    sm: 'px-2 py-0.5 text-xs',
    md: 'px-3 py-1 text-sm',
    lg: 'px-4 py-1.5 text-base',
  };

  const iconSizes = {
    sm: 'w-3 h-3',
    md: 'w-3.5 h-3.5',
    lg: 'w-4 h-4',
  };

  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full font-medium ${sizeClasses[size]}`}
      style={{
        color: config.color,
        backgroundColor: config.bgColor,
      }}
    >
      {showIcon && Icon && <Icon className={iconSizes[size]} />}
      {config.label}
    </span>
  );
};
